"use client";
import Navbar from "../../../../components/navbar";
import Footer from "../../../../components/footer";
import styles from "../css/index.js";
import PharmacyInfoForm from "../components/PharmacyInfoForm";
import LabelConfigurationStateProvider from "../components/LabelConfigurationStateProvider";
import LabelConfigurationHeader from "../components/LabelConfigurationHeader";
import MedicationFormsSection from "../components/MedicationFormsSection";
import LabelPreviewSection from "../components/LabelPreviewSection";
import PrintAllTracerButton from "../components/PrintAllTracerButton";

export default function LabelConfiguration() {
  return (
    <LabelConfigurationStateProvider>
      {({
        user,
        prescriptionId,
        navigationState,
        isFromDispensaryMenu,
        forms,
        pharmacyInfo,
        activeTab,
        setActiveTab,
        activePreviewId,
        setActivePreviewId,
        drugInfo,
        effectiveShowRepeat,
        repeatData,
        repeatNumberFromNav,
        receiptNumber,
        scriptNumber,
        handlePharmacyChange,
        addForm,
        removeForm,
        handleInputChange,
        fetchDrugInfoForPreview,
        handleDrugInfoUpdate,
      }) => (
        <div className={styles.container}>
          <Navbar />

          <main className={styles.main}>
            <div className={styles.content}>
              <div className={styles.topSection}>
                <div className={styles.configSection}>
                  <LabelConfigurationHeader
                    styles={styles}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    onAdd={addForm}
                  />

                  <MedicationFormsSection
                    styles={styles}
                    forms={forms}
                    activeTab={activeTab}
                    activePreviewId={activePreviewId}
                    setActivePreviewId={setActivePreviewId}
                    removeForm={removeForm}
                    handleInputChange={handleInputChange}
                    fetchDrugInfoForPreview={fetchDrugInfoForPreview}
                    prescriptionId={prescriptionId}
                    navigationState={navigationState}
                    scriptNumber={scriptNumber}
                    isFromDispensaryMenu={isFromDispensaryMenu}
                    pharmacyInfo={pharmacyInfo}
                    user={user}
                    drugInfo={drugInfo}
                    effectiveShowRepeat={effectiveShowRepeat}
                    repeatData={repeatData}
                    repeatNumberFromNav={repeatNumberFromNav}
                  />

                  <PrintAllTracerButton
                    styles={styles}
                    activeTab={activeTab}
                    forms={forms}
                    pharmacyInfo={pharmacyInfo}
                    user={user}
                    effectiveShowRepeat={effectiveShowRepeat}
                    repeatData={repeatData}
                    repeatNumberFromNav={repeatNumberFromNav}
                  />
                </div>

                <LabelPreviewSection
                  styles={styles}
                  activeTab={activeTab}
                  activePreviewId={activePreviewId}
                  forms={forms}
                  pharmacyInfo={pharmacyInfo}
                  drugInfo={drugInfo}
                  user={user}
                  receiptNumber={receiptNumber}
                  handleDrugInfoUpdate={handleDrugInfoUpdate}
                  effectiveShowRepeat={effectiveShowRepeat}
                  repeatData={repeatData}
                  repeatNumberFromNav={repeatNumberFromNav}
                  setActivePreviewId={setActivePreviewId}
                />
              </div>

              <PharmacyInfoForm
                pharmacyInfo={pharmacyInfo}
                onChange={handlePharmacyChange}
              />
            </div>
          </main>

          <Footer />
        </div>
      )}
    </LabelConfigurationStateProvider>
  );
}
